var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Footer } from '@redbubble/design-system';
import React from 'react';
import { MatureContentToggle, useMatureContentToggle, } from '../mature-content-toggle';
import { HeaderAndFooterVariant } from '../types';
export var AppFooter = function (_a) {
    var intl = _a.intl, userInfo = _a.userInfo, headAndFooterVariant = _a.headAndFooterVariant;
    var toggleMatureContent = useMatureContentToggle();
    if (headAndFooterVariant === HeaderAndFooterVariant.Static) {
        return (React.createElement(Footer, { intl: intl, userInfo: __assign({}, userInfo), showUserSettings: false }));
    }
    return (React.createElement(MatureContentToggle, null, function (showMatureContent) { return (React.createElement(Footer, { intl: intl, userInfo: __assign(__assign({}, userInfo), { showMatureContent: showMatureContent }), onToggleMatureContent: toggleMatureContent, showUserSettings: true })); }));
};
